(() => {
  // No third-party DOM inspection, Forms events, timer reset or app setting changes.
  // Automatic welcome display remains disabled until a supported Forms coordinator exists.
  const menus = () => document.querySelectorAll('.nekoan-header-language');
  document.addEventListener('click', event => {
    menus().forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    menus().forEach(menu => {
      if (!menu.open) return;
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  const dialog = document.getElementById('NekoanWelcome');
  if (!dialog || dialog.dataset.previewTest !== 'true' || window.Shopify?.designMode) return;
  const query = new URLSearchParams(location.search);
  const test = query.get('nekoan_localization_test');
  const key = 'nekoan.localization.preview.handled.v1';
  if (test === 'reset') {
    try { localStorage.removeItem(key); } catch (_) { /* Storage can be disabled. */ }
    query.delete('nekoan_localization_test');
    history.replaceState(null, '', `${location.pathname}?${query}${location.hash}`);
    return;
  }
  if (test !== '1') return;
  // Remove test flag before native form submission, preventing test recurrence on redirects.
  query.delete('nekoan_localization_test');
  history.replaceState(null, '', `${location.pathname}?${query}${location.hash}`);
  try { if (localStorage.getItem(key) === '1') return; } catch (_) { /* One-page test only. */ }
  let previousFocus;
  const handled = () => {
    try { localStorage.setItem(key, '1'); } catch (_) { /* No cross-page persistence if blocked. */ }
  };
  const close = () => { handled(); dialog.close(); };
  dialog.querySelector('.nekoan-welcome-close').addEventListener('click', close);
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('close', () => {
    document.body.classList.remove('nekoan-welcome-open');
    if (previousFocus?.isConnected) previousFocus.focus();
    else [...menus()].find(menu => menu.getClientRects().length)?.querySelector('summary').focus();
  });
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll('button, select, a[href], input:not([type=hidden])')].filter(node => !node.disabled && node.getClientRects().length);
    const first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  dialog.querySelector('form').addEventListener('submit', () => {
    handled();
    document.body.classList.remove('nekoan-welcome-open');
  });
  const show = () => {
    previousFocus = document.activeElement;
    dialog.showModal(); // Native dialog provides focus containment and Escape semantics.
    document.body.classList.add('nekoan-welcome-open');
    dialog.querySelector('.nekoan-welcome-close').focus();
  };
  // Explicit, unpublished-preview-only visual test. No automatic production trigger.
  // This does not claim to coordinate either Cookie Consent or Shopify Forms.
  const previewButton = document.createElement('button');
  previewButton.type = 'button';
  previewButton.className = 'nekoan-localization-test';
  previewButton.textContent = 'Preview country / language';
  previewButton.addEventListener('click', () => { previewButton.remove(); show(); }, {once: true});
  dialog.after(previewButton);
})();
